import Tippy from "@tippyjs/react";
import React, { forwardRef } from "react";
import { animateFill } from "tippy.js";
import { hideAllPoppersInstantly } from "helpers/randomHelpers";
import "tippy.js/dist/tippy.css";

const renderOptions = (options) => {
  let list = [];
  options.forEach((option, i) => {
    list.push(
      <div
        key={i}
        className={`more-options-item ${
          option.danger ? "delete-text-color font-bold" : ""
        } ${option.disabled || option.subtitle ? "disabled-option" : ""} ${
          option.active ? "business-text" : ""
        } ${option.subtitle ? "subtitle-text" : ""} ${
          option.noHover ? "noHovering" : ""
        } ${option.bigText ? "bigText" : ""} `}
        onClick={(e) => {
          if (option.disabled) {
            e.preventDefault();
            e.stopPropagation();
          } else if (option.action) option.action();
          if (!option.stayOpen) hideAllPoppersInstantly();
        }}
      >
        {option.text}
        {option.active && (
          <span className="tick">&#10003;&nbsp;&nbsp;&nbsp;</span>
        )}
      </div>
    );
  });
  return list;
};

const MoreOptionsTippy = forwardRef(
  ({ options, placement, customStyle, children, ...rest }, ref) => {
    return (
      <Tippy
        onShow={hideAllPoppersInstantly}
        delay={[0, 0]}
        className="content-only-Tippy"
        animateFill={true}
        plugins={[animateFill]}
        animation={"shift-away"}
        placement={placement}
        popperOptions={{
          modifiers: [
            {
              name: "preventOverflow",
              options: {
                altAxis: true,
                tether: false,
              },
            },
          ],
        }}
        content={
          <div
            className={`more-options-box`}
            style={customStyle ? customStyle : {}}
          >
            {renderOptions(options)}
          </div>
        }
        appendTo={document.getElementById("space-and-video")}
        hideOnClick={true}
        interactive
        arrow={false}
        trigger="click"
        {...rest}
      >
        {React.cloneElement(children, { ref: ref })}
      </Tippy>
    );
  }
);

export default MoreOptionsTippy;
